import { useQuery } from "@tanstack/react-query";
import { useProductionService } from "../services/production";
import type { ProductionLogQuery } from "@/shared/types/production";

export function useProductionLog(query: ProductionLogQuery) {
  const service = useProductionService();
  return useQuery({
    queryKey: ["production-log", query.fromMs, query.toMs],
    queryFn: () => service.getLog(query),
    staleTime: 60_000,       // 1 min
    refetchInterval: 5 * 60_000, // 5 min auto-refresh
  });
}
